import React from "react";
import { Grid } from "@material-ui/core";
import CustomErrorTemplate from "./CustomErrorTemplate";

function CustomFieldTemplate(props) {
  var id = props.id,
      classNames = props.classNames,
      metadata = props.schema.metadata,
      help = props.help,
      description = props.description,
      rawErrors = props.rawErrors,
      children = props.children;


  if (id === "root") {
    return React.createElement(
      "div",
      {
        className: classNames,
        style: { marginTop: "16px", marginBottom: "8px" }
      },
      description,
      children,
      React.createElement(CustomErrorTemplate, { errors: rawErrors }),
      help
    );
  }

  return React.createElement(
    Grid,
    { item: true, xs: metadata.cols * 1 },
    description,
    children,
    React.createElement(CustomErrorTemplate, { errors: rawErrors }),
    help
  );
}

export default CustomFieldTemplate;